import { render, staticRenderFns } from "./OutBlnftAmntAnnc.vue?vue&type=template&id=6b5a6b60&"
import script from "./OutBlnftAmntAnnc.vue?vue&type=script&lang=js&"
export * from "./OutBlnftAmntAnnc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports